export default __webpack_public_path__ + "static/media/rock.245d9f5c.png";